import styled from "styled-components"

export const HeaderStyles = styled.header`
  z-index: 3;
  ${'' /* position: fixed; */}
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 5vh 5vw 10vh 5vw;
  justify-content: center;
  grid-template-columns: 200px auto;
  grid-gap: 1rem;
  
  @media (min-width: 768px) {
       margin: 10vh 5vw 18vh 5vw;
      }
  
    ${'' /* background-color: #ffffff; */}
     
  .logo-cont {
    display: flex;
    flex-direction: row;
    ${'' /* justify-content: center; */}
padding-bottom: 2.5rem;
    z-index: 3;
    

    a {
      display: inline-block;
      line-height: 2.5rem;
      color: var(--black);
      text-decoration: none;
      transition: var(--transMed);
      position: relative;

      &:hover {
        color: var(--primaryColor);
      }
    }

    img {
      vertical-align: middle;
      width: 65px;

      @media (min-width: 768px) {
        width: 90px;
      }
    }

    h1 {
      margin: 0;
      font-size: 1.25rem;
      text-align: center

    }
      @media (min-width: 768px) {
        h1 {
       font-size: 1.75rem;
        }
      }
     
  }
 
`

export const NavigationStyles = styled.nav`
  @media (max-width: 767px) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
    right: 0;

background-color: #efefef;
    z-index: 2;
    transform: translateX(100%);
    transition: 0.3s;

    &.open {
      transform: translateX(0%);
    }

    ul {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }

  ul {
    height: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    text-transform: capitalize;

    li {
      ${'' /* padding-left: 2rem; */}
      margin-top: 1rem;
      ${'' /* margin-bottom: 1rem; */}
      font-size: 1.4rem;
      font-family: "Poppins";
      font-weight: 400;
    }
  }

  @media (min-width: 768px) {
      ul {
        align-items: center;
        li {
          font-size: 1.15rem;
          padding-left: 2rem;
          justify-content: flex-end;
        }
      }
    }

  .nav-link {
    ${'' /* font-weight: var(--heavyWeight); */}
    list-style: none;
    display: inline;

    a {
      display: inline-block;
      text-decoration: none;
      position: relative;
      -webkit-transition: 0.3s;
      transition:  0.3s;
      color: #000;
      line-height: 1.75rem;

      &:hover {
        color: #3e3e3e;

        &::after {
          width: 0;
          left: 100%;
        }
      }
    }
  }
`

export const BurgerStyles = styled.button`
  border: none;
  background-color: transparent;
  font-family: "Poppins";
  color:  #000;
   ${'' /* color:  #000; */}
  display: flex;
  align-items: center;
  padding: 0;
  z-index: 3;
  font-size: 1rem;

  &:focus {
    outline: none;
  }

  > div {
    margin-left: 8px;

    span {
      display: block;
      background-color:  #000;
       ${'' /* background-color:  #000; */}
      transition: width 0.3s ease;
      width: 30px;
      height: 1px;

      &:nth-child(1) {
        transform: translateY(-8px);
      }

      &:nth-child(3) {
        transform: translateY(8px);
      }
    }
  }

  &.open {
    > div {
      span {
        &:nth-child(2) {
          width: 20px;
        }

        &:nth-child(3) {
          width: 10px;
        }
      }
    }
  }

  @media (min-width: 768px) {
    display: none;
  }
`
